import ContactInfoFunctional from './Components/contactinfoFunctional';
import React from 'react';
import reducer from './reducer';
import sagas from './sagas';
import { withReducer } from '@store/reducerLoader';

const ContactInfoPage = ({ allowNavigate, navigateDisabled, buttonMode, buttonName }) => {
	return (
		<ContactInfoFunctional allowNavigate={allowNavigate} navigateDisabled={navigateDisabled} buttonMode={buttonMode} buttonName={buttonName} />
	);
};

const ReducedScreen = withReducer('contactinfo', reducer, sagas)(ContactInfoPage);
export default ReducedScreen;
